import React, { useEffect, useState } from "react";
import Tableform from "../../components/general/Tableform";
import { API } from "../../api";
import { errorToast, successToast } from "../../hooks/useToast";
import { timebasedcolumn } from "../../data/timebasedcolumn";
import { explanationBasedcolumn } from "../../data/explanationBasedcolumn";
import Loader from "../../components/general/Loader"; 
import MetaData from "../../components/seo/MetaData";
import LinkComponent3 from "../../components/general/LinkComponent3";

const MyExamsPage = () => {
  const [itemPerPage, setItemPerPage] = useState(5);
  const [timebased, setTimeBased] = useState([]);
  const [explanationBased, setExplanationBased] = useState([]);
  const [loadingTimeBased, setLoadingTimeBased] = useState(true);
  const [loadingExplanationBased, setLoadingExplanationBased] = useState(true);

  const fetchData = async (mode, setState, setLoadingState) => {
    const params = new URLSearchParams({ mode }).toString();

    try {
      const response = await API.userExam(params);

      if (response.status === 200) {
        setState(response.data.data || []);
      } else {
        errorToast("Failed to fetch data");
      }
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
      errorToast("There has been a problem with your fetch operation");
    } finally {
      setLoadingState(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await API.deleteUserExam(id);
      successToast("Deleted");
      fetchData("timeBased", setTimeBased, setLoadingTimeBased);
      fetchData(
        "explanationBased",
        setExplanationBased,
        setLoadingExplanationBased
      );
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData("timeBased", setTimeBased, setLoadingTimeBased);
    fetchData(
      "explanationBased",
      setExplanationBased,
      setLoadingExplanationBased
    );
  }, []);

  return (
    <div className="flex flex-col">
      <MetaData
        title={"Manage Exams - Qbank Model"}
        description={
          "Organize and schedule your exams with Qbank Model. Access exam details and prepare efficiently for your tests."
        }
        keywords={"exam management, Qbank Model, schedule exams, exam details"}
      />
      <div className="profile-header  py-4   interFont flex items-center w-full justify-between  ">
        <h2 className=" text-2xl interFont capitalize font-bold ">
          Your Exams{" "}
        </h2>
        <LinkComponent3 to={"/user/exam"} text={"Create Exam"} />
      </div>

      {loadingExplanationBased ? (
        <Loader />
      ) : (
        <>
          <Tableform
            tableheading="Time Based"
            filterdata={timebased}
            tablecolumns={timebasedcolumn}
            itemPerPage={itemPerPage}
            loading={loadingTimeBased}
            resultPreview={true}
            deletePreview={false}
            handleDelete={handleDelete}
            noContentText={"Create Your First Time Based Exam"}
          />

          <Tableform
            tableheading="Explanation Based"
            filterdata={explanationBased}
            tablecolumns={explanationBasedcolumn}
            itemPerPage={itemPerPage}
            loading={loadingExplanationBased}
            resultPreview={true}
            deletePreview={false}
            handleDelete={handleDelete}
            noContentText={"Create Your First Explanation Based Exam"}
          />
        </>
      )}
    </div>
  );
};

export default MyExamsPage;
